import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import HeaderFixedDesktop from './HeaderFixedDesktop';
import HeaderFixedMobile from './HeaderFixedMobile';

const HeaderFixed = (props) => {
    const authData = Array.isArray(props.data) && props.data.filter((item) => item.authorised_user === true);

    const [sectionName, setSectionName] = useState();
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setIsFixed(scrollPosition > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        switch (props.menuSection) {
            case 'personal':
            case undefined:
                setSectionName('personal');
                break;
            default:
                setSectionName(props.menuSection);
        }
    }, [props.menuSection]);

    const newMenuSortedData = props.data ? props.data.sort((a, b) => a.position - b.position) : [];

    return (
        <>
            {props.isShowNavModal && props.data && (
                <HeaderFixedMobile
                    data={newMenuSortedData}
                    sectionName={sectionName}
                    isLanding={props.isLanding}
                    authData={authData}
                    pageName={props.pageName}
                    promoDarkPage={props.promoDarkPage}
                    libre={props.libre}
                    isFixed={isFixed}
                />
            )}
            {!props.loading && props.data && (
                <HeaderFixedDesktop
                    data={newMenuSortedData}
                    sectionName={sectionName}
                    isLanding={props.isLanding}
                    authData={authData}
                    pageName={props.pageName}
                    promoDarkPage={props.promoDarkPage}
                    libre={props.libre}
                    isFixed={isFixed}
                    hasChatButton={props.hasChatButton}
                    isBlogPage={props.isBlogPage}
                />
            )}
        </>
    );
};

HeaderFixed.propTypes = {
    isShowNavModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
    isLanding: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    menuSection: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([undefined, null])]),
};

export default HeaderFixed;
